import type { TranslateDictionary } from './en.js';

export const Fi: TranslateDictionary = {
  'Start airplay': 'Käynnistä AirPlay',
  'Stop airplay': 'Lopeta AirPlay',
  Audio: 'Ääni',
  Captions: 'Tekstitykset',
  'Enable captions': 'Tekstitys päälle',
  'Disable captions': 'Poista tekstitys',
  'Start casting': 'Aloita suoratoisto',
  'Stop casting': 'Lopeta suoratoisto',
  'Casting to {device}': 'Lähetetään laitteelle {device}',
  'Enter fullscreen mode': 'Siirry kokokuvaan',
  'Exit fullscreen mode': 'Poistu kokokuvasta',
  Mute: 'Mykistä',
  Unmute: 'Poista mykistys',
  'Enter picture in picture mode': 'Ota kuva kuvassa -tila käyttöön',
  'Exit picture in picture mode': 'Poistu kuva kuvassa -tilasta',
  Play: 'Käynnistä',
  Pause: 'Tauko',
  'Playback rate': 'Toistonopeus',
  'Playback rate {playbackRate}': 'Toistonopeus {playbackRate}',
  Quality: 'Laatu',
  'Seek backward': 'Kelaa taaksepäin',
  'Seek forward': 'Kelaa eteenpäin',
  Settings: 'Asetukset',
  Auto: 'Automaattinen',
  'audio player': 'äänisoitin',
  'video player': 'videosoitin',
  volume: 'Äänenvoimakkuus',
  seek: 'Etsi',
  'closed captions': 'Tekstitykset',
  'current playback rate': 'nykyinen toistonopeus',
  'playback time': 'toistoaika',
  'media loading': 'mediaa ladataan',
  settings: 'Asetukset',
  'audio tracks': 'ääniraidat',
  quality: 'Laatu',
  play: 'käynnistä',
  pause: 'tauko',
  mute: 'mykistä',
  unmute: 'poista mykistys',
  'chapter: {chapterName}': 'luku: {chapterName}',
  live: 'suora',
  Off: 'Pois',
  'start airplay': 'käynnistä AirPlay',
  'stop airplay': 'lopeta AirPlay',
  'start casting': 'aloita suoratoisto',
  'stop casting': 'lopeta suoratoisto',
  'enter fullscreen mode': 'siirry kokokuvaan',
  'exit fullscreen mode': 'poistu kokokuvasta',
  'enter picture in picture mode': 'ota kuva kuvassa -tila käyttöön',
  'exit picture in picture mode': 'poistu kuva kuvassa -tilasta',
  'seek to live': 'siirry suoraan lähetykseen',
  'playing live': 'toistetaan suoraa lähetystä',
  'seek back {seekOffset} seconds': 'kelaa taaksepäin {seekOffset} sekuntia',
  'seek forward {seekOffset} seconds': 'kelaa eteenpäin {seekOffset} sekuntia',
  'Network Error': 'Verkkovirhe',
  'Decode Error': 'Dekoodausvirhe',
  'Source Not Supported': 'Lähdettä ei tueta',
  'Encryption Error': 'Salausvirhe',
  'A network error caused the media download to fail.':
    'Verkkovirhe aiheutti median latauksen epäonnistumisen.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Mediavirhe aiheutti toiston keskeytymisen. Media voi olla vioittunut tai selaimesi ei tue tätä muotoa.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Tapahtui ei-tuettu virhe. Palvelin tai verkko epäonnistui, tai selaimesi ei tue tätä muotoa.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Media on salattu eikä avaimia sen purkamiseen ole.',
};
